<div style="
  height: 100%;
  display: flex;
">
  <p-splitter
    layout="vertical"
  >
    <ng-template pTemplate>
      <app-invoice-list/>
    </ng-template>

    <ng-template pTemplate>
      <app-dunning-info
        [hidden]="!isDunningInfoShown()"
      />
    </ng-template>

    <ng-template pTemplate>
      <app-cart-items-list/>
    </ng-template>

    <ng-template pTemplate>

      <app-item-correction-list
        [hidden]="!isItemCorrectionShown()"
      />
    </ng-template>
  </p-splitter>
</div>
